export default __webpack_public_path__ + "static/media/front.025a959b.png";